import { initialFeatureFlagsState, FEATURE_FLAGS_ACTIONS } from './featureFlags.types'

export function featureFlagsReducer(state = initialFeatureFlagsState, { type, payload }) {
  switch (type) {
    case FEATURE_FLAGS_ACTIONS.SET_FEATURE_FLAGS_STATUS:
      return { ...state, status: payload }

    case FEATURE_FLAGS_ACTIONS.SET_FEATURE_FLAGS_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case FEATURE_FLAGS_ACTIONS.SET_FEATURE_FLAG:
      return {
        ...state,
        flags: {
          ...state.flags,
          [payload.key]: { enabled: payload.enabled, checkedAt: Date.now() }
        }
      }

    case FEATURE_FLAGS_ACTIONS.CLEAR_FEATURE_FLAGS_ERRORS:
      return { ...state, errors: [] }

    default:
      return state
  }
}
